import { CfgResolves } from 'components/sharpr/cfg/CfgService';
import { IdentityResolves } from 'components/sharpr/identity/IdentityService';
import { MenuResolves } from 'components/sharpr/menu/menuService';
import { ThemeResolves } from 'components/sharpr/theme/themeService';
import { PartnerLinksResolves } from 'components/sharpr/partnerLinks/service/PartnerLinksService';
import { AnnouncementResolves } from 'components/sharpr/announcement/service/AnnouncementService';
import KeyboardShortcuts from 'components/sharpr/shortcuts/Shortcuts';

export function hubLoggedinBaseRoute($urlRouterProvider, $stateProvider) {
	'ngInject';
	let resolves = {};
	IdentityResolves(resolves);
	CfgResolves(resolves);
	MenuResolves(resolves);
	ThemeResolves(resolves);
	PartnerLinksResolves(resolves);
	AnnouncementResolves(resolves);
	// default URL (Intel tab)
	$urlRouterProvider.otherwise('/404');
	// base route for ui-router
	$stateProvider.state('hub.loggedin', {
		abstract: true,
		resolve: resolves,
		template: '<div ui-view></div>',
	});

	KeyboardShortcuts();
}

// export function handle404Resolves($rootScope, $state) { 'ngInject';
// 	$rootScope.$on('$stateChangeError', function(event) {
// 		$state.go('/post/notFound');
// 	});
// 	$rootScope.$on('$stateChangeStart',
// 		function(event, toState, toParams, fromState, fromParams){
// 			if(toState.name !== 'login' && !UsersService.getCurrentUser()) {
// 				event.preventDefault();
// 				$state.go('login');
// 			}
// 		});
// }
